import { z } from 'zod';
const subjectSearchResponseSchema = z.object({
    results: z.array(z.object({
        entityId: z.number(),
        objectId: z.number().optional(),
        name: z.string(),
        type: z.string(),
        link: z.string().optional(),
    })),
});
export class ChatContextClient {
    constructor(authenticatedClient) {
        this.authenticatedClient = authenticatedClient;
        this.getContextSubjectSearch = async (data) => {
            const res = await this.authenticatedClient.get(`/chat/context/${data.contextIdentifier}/subject-search?query=${encodeURIComponent(data.query)}`);
            return subjectSearchResponseSchema.parse(res.data);
        };
    }
}
